import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  selector: 'email-texting-number-deleted-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './texting-number-deleted.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class TextingNumberDeletedTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<TextingNumberDeletedTemplateData>;
}

export type TextingNumberDeletedTemplateData = {
  title: string;
  p1: string;
  p2: string;
  p3: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
  support_email: string;
  button_link: string;
  button_text: string;
};

export const TextingNumberDeletedTemplateMocks: TextingNumberDeletedTemplateData[] = [
  {
    title: 'Company phone number deleted',
    p1: 'We have deleted your company phone number %{phone_numbers} for %{company_name}.',
    p2: 'If you had registered for 10DLC, your campaign has also been deleted from Twillio',
    p3: 'Exchanging text messages with candidates is no longer available for your account.',
    button_link: 'https://app.s.recruitee.com/#/settings/texting',
    button_text: 'Go to settings',
    footer: {
      text: 'Need help?',
      href: 'https://auth.recruitee.com/?intercom_open=true',
      label: 'Contact us',
      target: '_blank',
    },
    support_email: 'support@recruitee.com',
  },
];
